import React from 'react';

import { createStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

import { LumaTheme } from '../styles/getTheme';
import Typography from '../Typography';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportSteel },
  },
}: LumaTheme) =>
  createStyles({
    root: {
      backgroundColor: 'transparent',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      fontSize: 50,
      lineHeight: 1,
    },
    title: {
      marginTop: unit * 2,
      fontWeight: 600,
    },
    content: {
      color: colorSupportSteel,
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 18,
    },
  });

interface EmptyStateProps {
  classes: any;
  className?: string;
  icon: string;
  title: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ classes, className, children, icon, title }) => (
  <div className={classnames(classes.root, className)}>
    <span className={classes.icon} role="img" aria-label={icon}>
      {icon}
    </span>
    <Typography className={classes.title} variant="h5" color="primary" paragraph>
      {title}
    </Typography>
    {children && <div className={classes.content}>{children}</div>}
  </div>
);

export default withStyles(styles)(EmptyState);
